import React from 'react';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import { List } from '../../../List/List.es.js';
import { Box } from '../../../../primitives/Box/Box.es.js';
import { useAutocompleteDropdown } from './AutocompleteContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Items = forwardRef((props, ref) => {
  const _a = props, {
    itemProps,
    itemComponent,
    noResultsComponent: NoResultsComponent,
    noResultsLabel,
    highlightedIndex,
    getItemsLabel
  } = _a, rest = __objRest(_a, [
    "itemProps",
    "itemComponent",
    "noResultsComponent",
    "noResultsLabel",
    "highlightedIndex",
    "getItemsLabel"
  ]);
  const { items, isOpen, isGrouped, getDisabledOption, hasReachMaxValues } = useAutocompleteDropdown();
  if (items.length <= 0) {
    return /* @__PURE__ */ React.createElement(Box, __spreadValues({
      flex: "1 1 auto",
      overflowY: "auto",
      ref
    }, rest), /* @__PURE__ */ React.createElement(NoResultsComponent, null, noResultsLabel));
  }
  const renderGroups = () => {
    return items.reduce((acc, item, index) => {
      acc.groups.push(/* @__PURE__ */ React.createElement(React.Fragment, {
        key: `group-${index}`
      }, /* @__PURE__ */ React.createElement(List.Subheader, null, item.group), item.options.map((option) => {
        const optionIndex = acc.itemIndex++;
        return /* @__PURE__ */ React.createElement(List.Item, __spreadValues({
          key: `option-${optionIndex}`,
          isSelected: highlightedIndex === optionIndex,
          isDisabled: getDisabledOption == null ? void 0 : getDisabledOption(item)
        }, itemProps({ item: option, index: optionIndex, disabled: hasReachMaxValues })), itemComponent({ item: option, getItemsLabel }));
      })));
      return acc;
    }, { groups: [], itemIndex: 0 }).groups;
  };
  const renderItems = () => items.map((item, index) => /* @__PURE__ */ React.createElement(List.Item, __spreadValues({
    isSelected: highlightedIndex === index,
    key: `option-${index}`,
    disabled: getDisabledOption == null ? void 0 : getDisabledOption(item)
  }, itemProps({ item, index, disabled: hasReachMaxValues })), itemComponent({ item, getItemsLabel })));
  return /* @__PURE__ */ React.createElement(List, __spreadValues({
    as: "ul",
    flex: "1 1 auto",
    overflowY: "auto",
    py: "xs",
    ref
  }, rest), isOpen && (isGrouped ? renderGroups() : renderItems()));
});

export { Items };
//# sourceMappingURL=Items.es.js.map
